module.exports = __webpack_public_path__ + "static/service-cs-kroger-half-493f6723d6e24820bf02a8b9f553c7a4.jpg";